import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome"
import React, { FC } from "react"
import { GestureResponderEvent, StyleSheet, TouchableOpacityProps, View } from "react-native"
import { Button } from "../Button/Button"
import { Text } from "../Text/Text"
import {
  BOLD_TEXT,
  DropdownOptionPresetNames,
  dropdownOptionPresets,
  SPACER,
  TEXT,
} from "./DropdownMenu.presets"

interface DropDownOptionProps extends TouchableOpacityProps {
  title: string
  preset: DropdownOptionPresetNames
  first?: boolean
  selectOption: (event: GestureResponderEvent) => void
}

export const DropDownOption: FC<DropDownOptionProps> = (props) => {
  const { title, preset = "default", selectOption, first, ...rest } = props

  const viewStyle = StyleSheet.flatten([
    dropdownOptionPresets[preset] || dropdownOptionPresets.default,
  ])

  const textStyle = preset === "selected" ? BOLD_TEXT : TEXT

  return (
    <Button preset="tertiary" style={viewStyle} {...rest} onPress={selectOption}>
      <Text style={textStyle}>{title}</Text>
      <View style={SPACER} />
      {first && <FontAwesomeIcon icon="chevron-up" />}
    </Button>
  )
}
